import { Info } from '@mui/icons-material';
import { FormControlLabel, Switch } from '@mui/material';
import { FormStateDataType } from 'containers/dashboard/Forms/FormListingType';
import usePortalId from 'hooks/portal/usePortalId';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from 'utils/axios';

function ShowDropdown({
  setShowProductDropdown,
  showProductDropdown,
  formId,
  productDropdownInitial,
  setPublishFormData,
  formData,
  setFormUpdated,
  publishFormData,
  formUpdated,
  state,
  allowCustomProduct,
}: {
  setShowProductDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  showProductDropdown: boolean;
  productDropdownInitial: boolean;
  formId: string | undefined;
  setPublishFormData: React.Dispatch<React.SetStateAction<any>>;
  formData: any;
  setFormUpdated: React.Dispatch<React.SetStateAction<number>>;
  publishFormData: any;
  formUpdated: number;
  allowCustomProduct: boolean;
  state: FormStateDataType;
}) {
  const portalId = usePortalId();
  const { formDetails } = useSelector((state: any) => state.formEditor);
  const { products } = useSelector((state: any) => state.productsFromEditor);
  const { enqueueSnackbar } = useSnackbar();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const showPreview =
    (publishFormData && formUpdated !== 0) ||
    (state.selectedHubspotFormId && formData.hubspot_form_id !== '',
    formData.hubspot_form_id !== '');

  const showDropdown = () => {
    if (showProductDropdown === false) {
      setShowProductDropdown(true);
    } else {
      setShowProductDropdown(false);
    }
  };
  useEffect(() => {
    try {
      axiosInstance
        .post(
          '/formpayhome/portal/updatePortalFormSettings/' + formDetails.formId,
          {
            portalId: portalId,
            form_id: formId,
            show_product_dropdown: allowCustomProduct
              ? false
              : showProductDropdown,
          }
        )
        .then(resp => {
          if (resp.data.success === true) {
            if (showPreview) {
              setPublishFormData(resp.data.data);
            }
          }
        });
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [showProductDropdown, allowCustomProduct]);

  useEffect(() => {
    // @ts-ignore
    if (publishFormData && window.showPreviewForForm) {
      setFormUpdated(value => value + 1);
    }
  }, [publishFormData]);

  return (
    <>
      {showProductDropdown ? (
        <>
          {products?.length === 0 ? (
            <>
              <div className='mt-2 flex items-center text-[14px] text-gray-600 ml-1'>
                <Info sx={{ width: '15px', height: '15px' }} />{' '}
                <span className='ml-1'>No products added</span>
              </div>
            </>
          ) : (
            <>
              <div className='mt-2 flex items-center text-[14px] text-gray-600 ml-1'>
                <Info sx={{ width: '15px', height: '15px' }} />{' '}
                <span className='ml-1'>
                  At least one product should be default and all products must
                  be optional.
                </span>
              </div>
            </>
          )}
        </>
      ) : (
        <></>
      )}
      <FormControlLabel
        className='ml-0'
        control={
          <Switch
            name='showDropdown'
            onChange={showDropdown}
            checked={showProductDropdown}
            disabled={allowCustomProduct}
          />
        }
        label='Show Dropdown'
      />
    </>
  );
}

export default ShowDropdown;
